import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import EndOfMonthPopup from "./EndOfMonthPopup";
import Header from "./Header";
import QuestionnairListPopup from "./QuestionnairListPopup";
import StartOfMonthPopup from "./StartOfMonthPopup";
import UserActivityMonitor from "./UserActivityMonitor";

const ProtectedRoute = ({ roles, children }) => {
  const [currentPopupIndex, setCurrentPopupIndex] = React.useState(0);
  const [popups, setPopups] = React.useState([]);
  const [user, setUser] = React.useState(null);

  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token");
  const currentRole =
    localStorage.getItem("role") || sessionStorage.getItem("role");
  const authStatus = token ? true : false;
  const navigate = useNavigate();

  // Function to refresh user data from storage
  const refreshUserData = () => {
    // Small delay to ensure localStorage operations are complete
    setTimeout(() => {
      const userData = JSON.parse(
        localStorage.getItem("user") || sessionStorage.getItem("user") || 'null'
      );
      setUser(userData);
    }, 50);
  };

  // Initial load and storage event listener for user data updates
  React.useEffect(() => {
    refreshUserData();

    const handleStorageChange = (event) => {
      if (event.key === 'user') {
        refreshUserData();
      }
    };

    const handleUserDataUpdate = () => {
      refreshUserData();
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('userDataUpdated', handleUserDataUpdate);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('userDataUpdated', handleUserDataUpdate);
    };
  }, []);

  useEffect(() => {
    if (!authStatus) {
      navigate("/");
      return;
    }

    // Wait for user data to be available before checking profile picture
    if (!user) {
      return;
    }

    // Check if user has a profile picture (only if not already on profile page)
    const currentPath = window.location.pathname;
    if (currentPath !== "/profile") {
      const hasProfilePicture = user?.profile !== null && user?.profile !== undefined && user?.profile !== '';

      if (!hasProfilePicture) {
        navigate("/profile", { state: { requireProfilePicture: true } });
        return;
      }
    }
  }, [authStatus, navigate, user]);

  useEffect(() => {
    const newPopups = [];
    const shouldShowStartOfMonth = user?.startOfMonthNotification;
    const shouldShowEndOfMonth = user?.endOfMonthNotification;
    const shouldShowQuestionnaire = user?.displayWeeklyQuestions;

    if (shouldShowStartOfMonth) newPopups.push("startOfMonth");
    if (shouldShowEndOfMonth) newPopups.push("endOfMonth");
    if (shouldShowQuestionnaire) newPopups.push("questionnaire");

    setPopups(newPopups);
  }, [user?.startOfMonthNotification, user?.endOfMonthNotification, user?.displayWeeklyQuestions]);

  const handleNext = () => setCurrentPopupIndex((prev) => prev + 1);

  if (typeof roles !== "undefined" && !roles.includes(currentRole)) {
    return <p>You do not have permission to access this page</p>;
  }
  const currentPopup = popups[currentPopupIndex];

  return authStatus ? (
    <>
      {currentPopup === "startOfMonth" &&
        !window.location.pathname.includes("contract") && (
          <StartOfMonthPopup handleNext={handleNext} />
        )}
      {currentPopup === "endOfMonth" &&
        !window.location.pathname.includes("contract") && (
          <EndOfMonthPopup handleNext={handleNext} />
        )}
      {currentPopup === "questionnaire" &&
        !window.location.pathname.includes("contract") && (
          <QuestionnairListPopup handleNext={handleNext} />
        )}

      {currentPopupIndex >= popups.length && <UserActivityMonitor />}
      <Header />
      {children}
    </>
  ) : null;
};

export default ProtectedRoute;
